import { type Theme } from '@mui/material/styles';

export const styles = (theme: Theme) => ({
  ':root': {
    '--theme-palette-text-primary': theme.palette.text.primary,

    '--theme-palette-primary': theme.palette.primary.main,
    '--theme-palette-primary-light': theme.palette.primary.light,

    '--theme-palette-secondary': theme.palette.secondary.main,
    '--theme-palette-secondary-light': theme.palette.secondary.light,

    '--theme-palette-brand-black-main': theme.palette.brand.black.main,
    '--theme-palette-brand-vfile-main': theme.palette.brand.vfile.main,
    '--theme-palette-brand-vship-main': theme.palette.brand.vship.main,
    '--theme-palette-brand-vlearn-main': theme.palette.brand.vlearn.main,
    '--theme-palette-brand-vsuite-main': theme.palette.brand.vsuite.main,

    '--theme-palette-grey25': theme.palette.grey[25],
    '--theme-palette-grey50': theme.palette.grey[50],
    '--theme-palette-grey100': theme.palette.grey[100],
    '--theme-palette-grey200': theme.palette.grey[200],
    '--theme-palette-grey300': theme.palette.grey[300],
    '--theme-palette-grey400': theme.palette.grey[400],
    '--theme-palette-grey500': theme.palette.grey[500],
    '--theme-palette-grey600': theme.palette.grey[600],
    '--theme-palette-grey700': theme.palette.grey[700],
    '--theme-palette-grey800': theme.palette.grey[800],
    '--theme-palette-grey900': theme.palette.grey[900],
    '--theme-palette-greyA100': theme.palette.grey.A100,
    '--theme-palette-greyA200': theme.palette.grey.A200,
    '--theme-palette-greyA400': theme.palette.grey.A400,
    '--theme-palette-greyA700': theme.palette.grey.A700,
  },
});
